var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import IconButton from '@material-ui/core/IconButton';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { useForm, useFormRefs, useBaseI18n } from '../hooks';
import { useStyles as useFormFileStyles } from './FormFile';
import FormInput from './FormInput';
var FormDateTextField = function (_a) {
    var _b = _a.InputProps, _c = _b === void 0 ? {} : _b, id = _c.id, name = _c.name, InputProps = __rest(_c, ["id", "name"]), helperText = _a.helperText, rest = __rest(_a, ["InputProps", "helperText"]);
    var form = useForm();
    var refs = useFormRefs();
    var classes = useFormFileStyles();
    var cd = useBaseI18n(function (i18n) { return i18n.form.chooseDate; });
    var date = useMemo(function () { return form.values[id]; }, [form.values[id]]);
    var value = useMemo(function () { return date ? rest.value : cd; }, [date, cd]);
    return (_jsx(FormInput, __assign({ id: id, description: name, endAdornment: (_jsx(IconButton, __assign({ onClick: function () { return refs.current[id].focus(); }, color: "primary", className: classes.iconButton }, { children: _jsx(CalendarTodayIcon, { className: classes.svg }, void 0) }), void 0)) }, InputProps, rest, { value: value, readOnly: true }), void 0));
};
export default FormDateTextField;
//# sourceMappingURL=FormDateTextField.js.map